import { type ReactNode } from 'react';
import CssBaseline from '@mui/material/CssBaseline';
import {
  createTheme,
  ThemeProvider as MuiThemeProvider,
  type Theme
} from '@mui/material/styles';
import { useFuelTheme } from '@deere/fuel-react/useFuelTheme.js';
import { ThemeModeProvider, useThemeMode } from './ThemeModeContext';

type SlotProps = { theme: Theme };

function MuiThemeAndCSSProvider({ children }: { children: ReactNode }) {
  const { preference } = useThemeMode();
  const fuelTheme = useFuelTheme(
    { mode: preference },
    { bodyBackground: 'alternate' }
  );

  const theme = createTheme(fuelTheme, {
    components: {
      MuiDataGrid: {
        defaultProps: {
          slots: {
            columnSortedAscendingIcon: () => (
              <fuel-icon name="arrow_upward_alt" />
            ),
            columnSortedDescendingIcon: () => (
              <fuel-icon name="arrow_downward_alt" />
            ),
            columnUnsortedIcon: () => <fuel-icon name="swap_vertical" />
          }
        },
        styleOverrides: {
          main: {
            border: 'none'
          },
          columnSeparator: {
            opacity: 1
          },
          cell: {
            display: 'flex',
            alignItems: 'center'
          },
          columnHeader: {}
        }
      }
    }
  });

  return (
    <MuiThemeProvider theme={theme}>
      <CssBaseline />
      {children}
    </MuiThemeProvider>
  );
}

export const ApplicationThemeProvider = ({
  children
}: {
  children: ReactNode;
}) => {
  return (
    <ThemeModeProvider>
      <MuiThemeAndCSSProvider>{children}</MuiThemeAndCSSProvider>
    </ThemeModeProvider>
  );
};

export default ApplicationThemeProvider;
